"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _constants = require("./constants");
function cov_3xdv7ah6n() {
  var path = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/ThemeContext.js";
  var hash = "fdef257f027b4da631aa75d2e708ed5af2ca2e75";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/ThemeContext.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 21
        },
        end: {
          line: 7,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fdef257f027b4da631aa75d2e708ed5af2ca2e75"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_3xdv7ah6n = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_3xdv7ah6n();
var ThemeContext = (cov_3xdv7ah6n().s[0]++, /*#__PURE__*/_react.default.createContext({
  theme: _constants.TicketShopTheme.EQUILIBRIUM,
  variables: _constants.TicketShopThemeVariables[_constants.TicketShopTheme.EQUILIBRIUM]
}));
var _default = exports.default = ThemeContext;